import { render, staticRenderFns } from "./EditLearning.vue?vue&type=template&id=fad4b452&"
import script from "./EditLearning.vue?vue&type=script&lang=js&"
export * from "./EditLearning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports